import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';

const PAGE_SIZE = 10;

function Lessons(props) {
  const { data: { month } } = props;
  const [lessons, setLessons] = useState([]);
  const [lessonsTypes, setTypes] = useState([]);
  const [query, setQuery] = useState({ student: '', mother: '', professor: '', date: '' });
  const [page, setPage] = useState(1);

  const lessonsPath = `/lessons/get?month=${month}`;
  const typesPath = '/lessons/types/get';

  useEffect(() => {
    fetch(typesPath)
      .then((r) => r.json())
      .then((types) => {
        setTypes(types);
        return fetch(lessonsPath);
      })
      .then((r) => r.json())
      .then((data) => setLessons(data))
      .catch(console.log);
  }, []);

  function handleMonthChange(event) {
    event.persist();
    window.location.href = `/lessons?month=${event.target.value}`;
  }

  function getTypeAbbr(lessonType) {
    const t = lessonsTypes.find((x) => x.id === parseInt(lessonType, 10));
    return t ? t.abbr : lessonType;
  }

  function handleSearch(field, value) {
    setQuery((q) => ({ ...q, [field]: value }));
    setPage(1);
  }

  const filtered = lessons.filter((l) =>
    (l.Student && l.Student.name && l.Student.name.toLowerCase().includes(query.student.toLowerCase())) &&
    (l.Student && l.Student.mother && l.Student.mother.toLowerCase().includes(query.mother.toLowerCase())) &&
    (l.Professor && l.Professor.name && l.Professor.name.toLowerCase().includes(query.professor.toLowerCase())) &&
    (l.date || '').toLowerCase().includes(query.date.toLowerCase())
  );

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const pageStart = (page - 1) * PAGE_SIZE;
  const pageRows = filtered.slice(pageStart, pageStart + PAGE_SIZE);

  const totalHours = lessons.reduce((s, l) => s + (l.duration || 0), 0);
  const totalReplacements = lessons.filter((l) => l.replacement === 'Si').length;
  const activeProfessors = new Set(lessons.filter((l) => l.Professor).map((l) => l.Professor.name)).size;

  function pageButtons() {
    const btns = [];
    const show = new Set([1, totalPages, page, page - 1, page + 1].filter((p) => p >= 1 && p <= totalPages));
    const sorted = [...show].sort((a, b) => a - b);
    sorted.forEach((p, i) => {
      if (i > 0 && p - sorted[i - 1] > 1) {
        btns.push(<span key={`sep-${p}`} className="les-page-sep">…</span>);
      }
      btns.push(
        <button key={p} className={`les-page-btn${page === p ? ' les-page-active' : ''}`} onClick={() => setPage(p)}>{p}</button>
      );
    });
    return btns;
  }

  return (
    <div className="les-wrap">

      {/* ── Stats ── */}
      <div className="les-stats">
        <div className="les-stat">
          <div className="les-stat-value">{lessons.length}</div>
          <div className="les-stat-label">Clases realizadas</div>
        </div>
        <div className="les-stat">
          <div className="les-stat-value">{totalHours}h</div>
          <div className="les-stat-label">Horas totales</div>
        </div>
        <div className="les-stat">
          <div className="les-stat-value">{totalReplacements}</div>
          <div className="les-stat-label">Reemplazos</div>
        </div>
        <div className="les-stat">
          <div className="les-stat-value">{activeProfessors}</div>
          <div className="les-stat-label">Profesores activos</div>
        </div>
      </div>

      {/* ── Table panel ── */}
      <div className="les-panel">
        <div className="les-panel-header">
          <div className="les-panel-title">
            <div className="les-panel-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
            </div>
            <div>
              <h2>{month || 'Clases'}</h2>
              <p>Haz clic en una fila para ver o editar el detalle</p>
            </div>
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px', flexWrap: 'wrap' }}>
            <span className="les-month-label">Mes</span>
            <select className="les-month-select" value={month || ''} onChange={handleMonthChange}>
              <option value="">Seleccione el mes</option>
              <option value="Marzo">Marzo</option>
              <option value="Abril">Abril</option>
              <option value="Mayo">Mayo</option>
              <option value="Junio">Junio</option>
              <option value="Julio">Julio</option>
              <option value="Agosto">Agosto</option>
              <option value="Septiembre">Septiembre</option>
              <option value="Octubre">Octubre</option>
              <option value="Noviembre">Noviembre</option>
              <option value="Diciembre">Diciembre</option>
            </select>
            <span className="les-count-badge">{filtered.length} clases</span>
          </div>
        </div>

        {/* ── Search row ── */}
        <div className="les-search-row">
          <div className="les-search-box">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="rgb(180,130,70)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input type="text" placeholder="Buscar alumno/a…" value={query.student} onChange={(e) => handleSearch('student', e.target.value)} />
          </div>
          <div className="les-search-box">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="rgb(180,130,70)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input type="text" placeholder="Buscar apoderado/a…" value={query.mother} onChange={(e) => handleSearch('mother', e.target.value)} />
          </div>
          <div className="les-search-box">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="rgb(180,130,70)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input type="text" placeholder="Buscar profesor/a…" value={query.professor} onChange={(e) => handleSearch('professor', e.target.value)} />
          </div>
          <div className="les-search-box">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="rgb(180,130,70)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>
            <input type="text" placeholder="Buscar fecha…" value={query.date} onChange={(e) => handleSearch('date', e.target.value)} />
          </div>
        </div>

        {/* ── Table ── */}
        <div style={{ overflowX: 'auto' }}>
          <table className="les-table">
            <thead>
              <tr>
                <th>Alumno/a</th>
                <th>Apoderado/a</th>
                <th>Profesor/a</th>
                <th>Fecha</th>
                <th>Materia</th>
                <th>Duración</th>
                <th>Reemplazo</th>
                <th>Tipo</th>
              </tr>
            </thead>
            <tbody>
              {filtered.length === 0 ? (
                <tr>
                  <td colSpan="8" style={{ padding: 0 }}>
                    <div className="les-empty">
                      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="rgb(180,130,70)" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" style={{ opacity: 0.4 }}><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                      <p className="les-empty-title">Sin clases registradas</p>
                      <p className="les-empty-sub">No hay clases que coincidan con la búsqueda</p>
                    </div>
                  </td>
                </tr>
              ) : (
                pageRows.map((lesson) => (
                  <tr key={lesson.id} onClick={() => { window.location.href = `/lessons/${lesson.id}`; }}>
                    <td className="les-td-name">{lesson.Student ? lesson.Student.name : '—'}</td>
                    <td className="les-td-mother">{lesson.Student ? lesson.Student.mother : '—'}</td>
                    <td className="les-td-prof">{lesson.Professor ? lesson.Professor.name : '—'}</td>
                    <td>{lesson.date}</td>
                    <td>{lesson.lecture}</td>
                    <td><span className="les-dur-badge">{lesson.duration}h</span></td>
                    <td><span className={`les-repl-badge${lesson.replacement === 'Si' ? ' les-repl-yes' : ' les-repl-no'}`}>{lesson.replacement}</span></td>
                    <td><span className="les-type-badge">{getTypeAbbr(lesson.lesson_type)}</span></td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>

        {/* ── Pagination ── */}
        <div className="les-pagination">
          <span className="les-page-info">
            {filtered.length
              ? `Mostrando ${pageStart + 1}–${Math.min(pageStart + PAGE_SIZE, filtered.length)} de ${filtered.length}`
              : 'Sin resultados'}
          </span>
          <div className="les-page-btns">
            <button className="les-page-btn" disabled={page === 1} onClick={() => setPage((p) => p - 1)}>‹</button>
            {pageButtons()}
            <button className="les-page-btn" disabled={page === totalPages || totalPages === 0} onClick={() => setPage((p) => p + 1)}>›</button>
          </div>
        </div>
      </div>

    </div>
  );
}

export default hot(module)(Lessons);
